import React, {
  ChangeEvent, FocusEvent, useEffect, useState,
} from 'react';
import MUITextField from '@mui/material/TextField';

interface Props {
  hidden?: boolean,
  disabled?: boolean,
  value: { textValue: string },
  onChange(value: any): void,
  label: string,
  required: boolean,
  onBlur(event: FocusEvent<HTMLInputElement>): void,
  onFocus(event: FocusEvent<HTMLInputElement>): void,
  withError?: boolean,
  helperText?: string,
  rows?: number,
}

const TextField: React.FC<Props> = ({
  hidden = false,
  disabled,
  value,
  onChange,
  label,
  required,
  withError,
  helperText,
  rows,
}: Props) => {
  const [isBlur, setIsBlur] = useState(false);
  const [isEmpty, setIsEmpty] = useState(true);
  const [textValue, setTextValue] = useState<string>(value.textValue || '');
  const [textHelper, setTextHelper] = useState<string|undefined>(helperText);

  const handleError = () => (
    required && isEmpty && (withError || isBlur)
  );

  useEffect(() => {
    setTextHelper(handleError() ? 'This field is required' : helperText);
  }, [handleError()]);

  const handleFocus = () => {
    setIsBlur(false);
  };

  const handleBlur = () => {
    setIsBlur(true);

    setIsEmpty(false);
    textValue === '' ? setIsEmpty(true) : setIsEmpty(false);
  };

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    const inputValue = event.target.value;

    setTextValue(inputValue);
    setIsEmpty(false);

    onChange({ textValue: inputValue });
  };

  return (
    <>
      {!hidden
        && (
          <MUITextField
            data-testid={label}
            variant="outlined"
            multiline
            rows={rows}
            value={textValue}
            onChange={handleChange}
            label={label}
            disabled={disabled}
            required={required}
            fullWidth
            error={handleError()}
            helperText={textHelper}
            onBlur={handleBlur}
            onFocus={handleFocus}
            hidden={hidden}
          />
        )}
    </>
  );
};

export default TextField;
